import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HeroCarousel from '../Common/HeroCarousel';
import waterImage from '../../Assets/Give 1.png';
import handsImage from '../../Assets/Give 2.png';

const Giving = () => {
  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <HeroCarousel 
        title="Give"
        height="h-96"
        contentPosition="bottom"
      />

      {/* Hidden div to maintain structure */}
      <div className="hidden">
        <div className="container mx-auto px-6 md:px-12 lg:px-24 pb-12">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Give</h1>
          <p className="text-white text-lg md:text-xl max-w-2xl font-sf-pro">
            Ways you can partner financially with House of Praise Healing and Prophetic Ministries
          </p>
        </div>
      </div>

      {/* Designate Your Offering Section */}
      <div className="bg-white pt-16 pb-0">
        <div className="text-center mb-12 container mx-auto px-6 md:px-12 lg:px-24">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Designate Your Offering</h2>
          <p className="text-gray-600 font-sf-pro max-w-3xl mx-auto">
            Your generous giving helps us serve our community, support missions, and spread God's love to those in need.
          </p>
        </div>

        {/* Giving Options Grid */}
        <div className="space-y-0">
            {/* Tithes & Offerings - Image Left, Content Right */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
              <div className="relative h-64 md:h-96">
                <img 
                  src={waterImage} 
                  alt="Tithes & Offerings" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="bg-black text-white p-8 md:p-12 flex flex-col justify-center">
                <div className="w-16 h-2 bg-teal-500 mb-6"></div>
                <h3 className="text-2xl md:text-3xl font-bold mb-4">Tithes & Offerings</h3>
                <p className="text-gray-300 font-sf-pro leading-relaxed">
                  This general fund covers the operating expenses of House of Praise Healing and Prophetic Ministries
                </p>
              </div>
            </div>

            {/* Mission Offerings - Content Left, Image Right */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
              <div className="bg-black text-white p-8 md:p-12 flex flex-col justify-center order-2 md:order-1">
                <div className="w-16 h-2 bg-teal-500 mb-6"></div>
                <h3 className="text-2xl md:text-3xl font-bold mb-4">Mission Offerings</h3>
                <p className="text-gray-300 font-sf-pro leading-relaxed">
                  This helps to plant more churches of House of Praise Healing and Prophetic Ministries in Nigeria.
                </p>
              </div>
              <div className="relative h-64 md:h-96 order-1 md:order-2">
                <img 
                  src={handsImage} 
                  alt="Mission Offerings" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
      </div>

      {/* Church Account Section */}
      <div className="bg-teal-900 text-white py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">Church Account Number</h2>
            
            <div className="space-y-4">
              <div className="flex justify-between items-center border-b border-teal-700 pb-3">
                <span className="font-sf-pro text-lg">Account NO:</span>
                <span className="font-bold text-xl">239 175 2787</span>
              </div>
              
              <div className="flex justify-between items-center border-b border-teal-700 pb-3">
                <span className="font-sf-pro text-lg">Bank Name:</span>
                <span className="font-bold text-xl">Zenith Bank</span>
              </div>
              
              <div className="flex justify-between items-center border-b border-teal-700 pb-3">
                <span className="font-sf-pro text-lg">Account Name:</span>
                <span className="font-bold text-xl">James Hauwa</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Giving;